import { render } from "./EPIC_COMMENTS.vue?vue&type=template&id=b7172e16&ts=true"
import script from "./EPIC_COMMENTS.vue?vue&type=script&lang=ts"
export * from "./EPIC_COMMENTS.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__